import { required, maxLength, minLength, numeric, integer, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    variant: {
      code: {
        // required: helpers.withMessage(i18n.global.t('Please enter a product variant code.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant code cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant code must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product variant codes can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      barcode: {
        required: helpers.withMessage(i18n.global.t('Please enter a product variant barcode.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant barcode cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant barcode must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product variant barcodes can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a product variant name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant name must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Product variant names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/&+.,'"()% -]+$/)),
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Product variant name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('English product names can include English letters, numbers, and certain special characters.'), helpers.regex(/^[A-Za-z0-9-_/&+.,'"()% ]+$/)),
      },
      price: {
        required: helpers.withMessage(i18n.global.t('Please enter a product variant price.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the product variant price.'), numeric)
      },
      compare_at_price: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the compare at price.'), numeric),
        greaterThanPrice: helpers.withMessage(
          i18n.global.t('Compare at price must be higher than the price.'),
          (value) => !value || Number(value) > Number(formState.price)
        )
      },
      dine_in_only: {
      },
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required),
      },
      serving_size_value: {
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the serving size.'), numeric),
      },
      serving_size_unit_id: {
        required: helpers.withMessage(i18n.global.t('Please enter a product serving size unit.'), requiredIf(formState.serving_size_value > 0)),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      unit_id: {
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      attributes: {
        required: helpers.withMessage(i18n.global.t('Please select all options.'), required),
        $each: helpers.forEach({
          id: {
            required: helpers.withMessage(i18n.global.t('Please select all options.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
          option_id: {
            required: helpers.withMessage(i18n.global.t('Please select all options.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
        })
      },
      description: {
        pattern: helpers.withMessage(i18n.global.t('Description contains invalid characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_.,!@#$%^&*()+=:;<>?/\|\[\]{}"'\s<>]+$/))
      },
      // คำอธิบายอังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้คำอธิบายไทย
      description_en: {
        pattern: helpers.withMessage(i18n.global.t('Description contains invalid characters.'), helpers.regex(/^[A-Za-z0-9-_.,!@#$%^&*()+=:;<>?/\|\[\]{}"'\s<>]+$/))
      },
      image: {
      },
      cost_manual: {}
    }
  }
};
